import React from 'react';
import { Outlet } from 'react-router-dom';
import { IDeviceStateControllerReturn } from '../../../../../../commonreact/main/services/devicestate/DeviceStateController.ts';
import PublicFooter from '../../footer/PublicFooter.tsx';
import { NavSidebarExpandProvider } from '../../navigationbars/NavSidebarExpandProvider.tsx';
import PublicNavbar from '../../navigationbars/PublicNavBar/PublicNavbar.tsx';
import { PublicNavbarController } from '../../navigationbars/PublicNavBar/PublicNavbarController.tsx';
import AppCSSService from '../../../services/AppCSSService.ts';
import { IEditBaseControllerReturn } from '../../../controllers/EditBaseController.ts';

/**
 * @abstract wrapper for public routes
 */
interface IProps {
  ebc: IEditBaseControllerReturn;
  dsc: IDeviceStateControllerReturn;
}
export const PublicLayoutWrapper = React.memo((props: IProps) => {

  const pnc = PublicNavbarController({ dsc: props.dsc });

  return (
    <>
      <div className={`min-h-screen flex-1 justify-center h-auto bg-black cursor-default ${(props.dsc.isMobile) ? AppCSSService.textDefault : AppCSSService.textBig}}`}>

        <PublicNavbar ebc={props.ebc} pnc={pnc} dsc={props.dsc} />

        {(!pnc.menuIsOpen) ? <>
          {/* <div className={`${props.dsc.small ? "w-full" : "w-10/12"} flex justify-center overflow-auto pt-8  mx-auto`} > */}
          <div className={`${(props.dsc.small || props.dsc.isMobile) ? "w-full" : "max-w-[1535px]"} flex justify-center overflow-auto pt-8  mx-auto`} >
            <Outlet />
          </div>

            <PublicFooter dsc={props.dsc} />
          </> : <div className='bg-gray-900 h-screen'></div>
        }

      </div>
    </>
  );
});

export default function PrivateLayout(props: IProps) {
  //console.log("PrivateLayout START")
  return (
    <NavSidebarExpandProvider>
      <div className={"w-full"}>
        <PublicLayoutWrapper ebc={props.ebc} dsc={props.dsc} />
      </div>
    </NavSidebarExpandProvider>
  );
}
